import {
    RemoveFavourites,
    RemoveFavouritesCallback,
    RemoveFavouritesContractModel,
    RemoveMultipleFavourites,
} from "@next/eventservice"
import {FavouritesApiPost} from "../../api/favourites"

const removeFavouritesESB = new RemoveFavourites()
const removeFavouritesCallbackESB = new RemoveFavouritesCallback()
const removeMultipleFavouritesESB = new RemoveMultipleFavourites()

export const SubscribeToFavouritesRemove = (siteUrl: string) => {
    removeFavouritesESB.subscribe(data => {
        LoadFavouritesApiData(siteUrl, data)
    })
}

export const SubscribeToFavouritesRemoveMultiple = (siteUrl: string) => {
    removeMultipleFavouritesESB.subscribe(data => {
        LoadRemoveMultipleFavouritesApiData(siteUrl, data)
    })
}
class FavouritesRemoveApiModel {
    itemNumber = 0
    optionCode = ""
    linkedItemNumber = ""
    linkedOptionNo = ""
    listId = 0
}

const LoadFavouritesApiData = (url: string, data: RemoveFavouritesContractModel) => {
    const apiModel = new FavouritesRemoveApiModel()
    apiModel.itemNumber = data.itemNumber
    apiModel.optionCode = data.optionCode
    apiModel.linkedItemNumber = data.linkedItemNumber
    apiModel.linkedOptionNo = data.linkedOptionNo
    apiModel.listId = data.listId
    FavouritesApiPost(apiModel, `${url}/favourite/remove`, removeFavouritesCallbackESB, data.eventId)
}

export const LoadRemoveMultipleFavouritesApiData = (url: string, data: RemoveFavouritesContractModel[]) => {
    data.forEach(item => {
        LoadFavouritesApiData(url, item)
    })
}
